module.exports = "/images/cookie_policy_hero.svg?f3d331e412532c65a5ef84b1bb9cd057";